import "./App.css";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import HomeScreen from "./pages/HomeScreen";

const router = createBrowserRouter([
  {
    path: "/",
    element: <HomeScreen />,
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
